import React from 'react';
import { cn } from 'helpers/utils/classnames';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, ...props }, ref) => {
  const Comp = 'button';
  return <Comp className={cn(className)} ref={ref} {...props} />;
});
Button.displayName = 'Button';

export { Button };
